



























































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import pdf from "vue-pdf";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import StoreSuketPengawetanJenazah from "@/store/modules/SuketPengawetanJenazah";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { parseLocalDate } from "@/utils/localDate";
import {
  PengawetanJenazahContent,
  SuketPengawetanJenazahItem,
  SuketPengawetanJenazahPayload
} from "@/types/suket_pengawetan_jenazah";

const JABATAN_DEFAULT = "Dokter Spesialis Forensik dan Medikolegal";

const NAMA_HARI = [
  "Minggu",
  "Senin",
  "Selasa",
  "Rabu",
  "Kamis",
  "Jumat",
  "Sabtu"
];

const TIME_CARRIER = { year: 2000, month: 0, day: 1 };

function defaultContent(): PengawetanJenazahContent {
  return {
    jabatan: JABATAN_DEFAULT,
    pengawetan: {
      tanggal: moment().format("YYYY-MM-DD"),
      jam_mulai: null,
      jam_selesai: null,
      volume_formalin: null,
      maksimal_hari: null
    },
    jenazah: { alamat_yogyakarta: null },
    pemohon: { nama: null, alamat: null, pekerjaan: null, hubungan: null }
  };
}

function timeToDate(value: string | null): Date | null {
  if (!value || !/^\d{2}:\d{2}$/.test(value)) {
    return null;
  }

  const [hour, minute] = value.split(":").map(Number);

  return new Date(
    TIME_CARRIER.year,
    TIME_CARRIER.month,
    TIME_CARRIER.day,
    hour,
    minute
  );
}

function dateToTime(value: Date | null): string | null {
  return value ? moment(value).format("HH:mm") : null;
}

function isEmpty(value: unknown): boolean {
  return value === null || value === undefined || `${value}`.trim() === "";
}

@Component({
  components: {
    BaseSuketCard,
    CardModalTtd,
    VCDateTimePicker,
    pdf
  }
})
export default class SuketPengawetanJenazahTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.PengawetanJenazah);
  suketStore = StoreSuketPengawetanJenazah;

  register_id: string | number = this.register;
  pasien_rm: string | number = this.pasien.rm;
  unit_id: string = this.user.unit_id;
  surat_date: string = moment().format("YYYY-MM-DD");
  signee_user_id: number | null = this.defaultSignee();
  creator_user_id: number = this.user.id;
  content: PengawetanJenazahContent = defaultContent();

  saving = false;
  loadedRatio = 0;
  validasi = [v => !isEmpty(v) || "*Kolom ini harus diisi"];

  hubunganOptions = [
    "Suami",
    "Istri",
    "Anak",
    "Ayah",
    "Ibu",
    "Saudara Kandung",
    "Kerabat"
  ];

  get dataSuket(): SuketPengawetanJenazahItem | null {
    return StoreSuketPengawetanJenazah.suket;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.listAll;
  }

  get today(): Date {
    return moment()
      .endOf("day")
      .toDate();
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.PengawetanJenazah, this.dataSuket.id)
      : null;
  }

  get hariPengawetan(): string {
    const tanggal = parseLocalDate(this.content.pengawetan.tanggal);

    return tanggal ? NAMA_HARI[tanggal.getDay()] : "-";
  }

  get tanggalPengawetan(): Date | null {
    return parseLocalDate(this.content.pengawetan.tanggal);
  }

  set tanggalPengawetan(value: Date | null) {
    this.content.pengawetan.tanggal = value
      ? moment(value).format("YYYY-MM-DD")
      : null;
  }

  get jamMulai(): Date | null {
    return timeToDate(this.content.pengawetan.jam_mulai);
  }

  set jamMulai(value: Date | null) {
    this.content.pengawetan.jam_mulai = dateToTime(value);
  }

  get jamSelesai(): Date | null {
    return timeToDate(this.content.pengawetan.jam_selesai);
  }

  set jamSelesai(value: Date | null) {
    this.content.pengawetan.jam_selesai = dateToTime(value);
  }

  get tanggalSurat(): Date | null {
    return parseLocalDate(this.surat_date);
  }

  set tanggalSurat(value: Date | null) {
    this.surat_date = value
      ? moment(value).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
  }

  get input(): SuketPengawetanJenazahPayload {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id,
      content: this.content
    };
  }

  get canSign(): boolean {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }

    this.hydrate(this.dataSuket);
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketPengawetanJenazahItem | null) {
    this.hydrate(val);
  }

  defaultSignee(): number | null {
    return (userModule.user.profesi || "").toLowerCase() === "dokter"
      ? userModule.user.id
      : null;
  }

  defaultAlamatYogyakarta(): string | null {
    const domisili = (this.pasien?.alamat_domisili || "").trim();

    return domisili && domisili !== (this.pasien?.alamat || "").trim()
      ? domisili.slice(0, 150)
      : null;
  }

  hydrate(d: SuketPengawetanJenazahItem | null) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date
      ? moment(d.surat_date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    this.signee_user_id = d ? d.signee_user_id : this.defaultSignee();
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const base = defaultContent();
    const c = d?.content;

    if (!c) {
      base.jenazah.alamat_yogyakarta = this.defaultAlamatYogyakarta();
      this.content = base;
      return;
    }

    this.content = {
      jabatan: c.jabatan || base.jabatan,
      pengawetan: { ...base.pengawetan, ...(c.pengawetan || {}) },
      jenazah: { ...base.jenazah, ...(c.jenazah || {}) },
      pemohon: { ...base.pemohon, ...(c.pemohon || {}) }
    };
  }

  save() {
    if (this.saving) {
      return;
    }

    const { pengawetan, pemohon } = this.content;
    const wajib: Array<[unknown, string]> = [
      [this.signee_user_id, "Dokter penanda tangan"],
      [this.content.jabatan, "Jabatan"],
      [pengawetan.tanggal, "Tanggal pengawetan"],
      [pengawetan.jam_mulai, "Jam mulai"],
      [pengawetan.jam_selesai, "Jam selesai"],
      [pengawetan.volume_formalin, "Volume formalin"],
      [pengawetan.maksimal_hari, "Lama pengawetan maksimal"],
      [pemohon.nama, "Nama pemohon"],
      [pemohon.alamat, "Alamat pemohon"],
      [pemohon.hubungan, "Hubungan keluarga dengan almarhum"]
    ];

    const kosong = wajib.filter(item => isEmpty(item[0])).map(item => item[1]);
    if (kosong.length) {
      appModule.sendErrorAlert(`Kolom wajib belum diisi: ${kosong.join(", ")}`);
      return;
    }

    if (Number(pengawetan.volume_formalin) <= 0) {
      appModule.sendErrorAlert("Volume formalin harus lebih dari 0 liter");
      return;
    }

    if (
      !Number.isInteger(Number(pengawetan.maksimal_hari)) ||
      Number(pengawetan.maksimal_hari) < 1
    ) {
      appModule.sendErrorAlert(
        "Lama pengawetan maksimal harus bilangan bulat minimal 1 hari"
      );
      return;
    }

    if (moment(pengawetan.tanggal, "YYYY-MM-DD").isAfter(moment(), "day")) {
      appModule.sendErrorAlert("Tanggal pengawetan tidak boleh di masa depan");
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.closeInput();
        StoreSuketPengawetanJenazah.getSuketByRegister(this.register);

        if (this.canSign) {
          this.showSignatureModal();
        }
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
